/**
 * Bilibili Tab 常量配置（按 2026-05-25 需求更新）
 *
 * - BILIBILI_TABLE_METRICS：表格 6 列指标，全部 B 站 API 返回真实数据 + 全部支持排序
 * - BILIBILI_CARD_METRICS：卡片底部 3 项（Views / 弹幕数 / Likes）
 * - BILIBILI_SORT_OPTIONS：Sort By 下拉选项（与表格列一致 6 项，避免 Table↔Card 视图切换时 sort by 值脱离 options）
 */

import { DBO_V } from '@op/utils/format';

export interface IBilibiliMetricItem {
  /** 数据字段名（对应 B 站 API item 中的 key） */
  key: string;
  /** 指标展示名称（intl id） */
  label: string;
  /** 自定义格式化，缺省走 DBO_V.reviews */
  format?: (value: string | number) => string | number;
}

/**
 * 表格 6 列指标（按 PRD 顺序）—— 全部 sortable
 *
 * API 排序白名单（sort_item）：view_count / danmaku_count / like_count / coin_count / favorite_count / share_count
 */
export const BILIBILI_TABLE_METRICS: IBilibiliMetricItem[] = [
  { key: 'view_count', label: 'Views' },
  { key: 'danmaku_count', label: 'Danmu' },
  { key: 'like_count', label: 'Likes' },
  { key: 'coin_count', label: 'Coins' },
  { key: 'share_count', label: 'Shares' },
  { key: 'favorite_count', label: 'Favorites' },
];

/** 卡片底部 3 项 metrics（按 Figma） */
export const BILIBILI_CARD_METRICS: IBilibiliMetricItem[] = [
  { key: 'view_count', label: 'Views', format: DBO_V.reviews },
  { key: 'danmaku_count', label: 'Danmu', format: DBO_V.reviews },
  { key: 'like_count', label: 'Likes', format: DBO_V.reviews },
];

export const BILIBILI_SORT_OPTIONS: Array<{ text: string; value: string }> = [
  { text: 'Date', value: 'publish_time' },
  { text: 'Views', value: 'view_count' },
  { text: 'Danmu', value: 'danmaku_count' },
  { text: 'Likes', value: 'like_count' },
  { text: 'Coins', value: 'coin_count' },
  { text: 'Shares', value: 'share_count' },
  { text: 'Favorites', value: 'favorite_count' },
];

/** 默认排序：PRD 明确「默认按 view_count 降序」 */
export const BILIBILI_DEFAULT_SORT = {
  by: 'view_count',
  order: 'desc' as const,
};
